var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EntryList"},[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),_vm._l((_vm.matchedEntries),function(entry){return _c('div',{key:entry.sys.id,class:{
			entry: true,
			selectable: _vm.selectable,
			selected: entry.selected,
			marked: entry.marked,
		},on:{"click":function($event){return _vm.clickEntry(entry)}}},[_c('v-row',[_c('v-col',[_vm._v(" "+_vm._s(entry.fields.title ? entry.fields.title.de : 'NO_TITLE')+" ")])],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }